import { render, staticRenderFns } from "./PbcPost.vue?vue&type=template&id=d83ead68&"
import script from "./PbcPost.vue?vue&type=script&lang=js&"
export * from "./PbcPost.vue?vue&type=script&lang=js&"
import style0 from "./PbcPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports